// Hotkey 타입 정의
type HotkeyHandler = (e: KeyboardEvent) => void;
type HotkeyMap = Map<string, HotkeyHandler>;

// 전역 핫키 맵
const hotkeys: HotkeyMap = new Map();
let isInitialized = false;

// 핫키 핸들러에 디바운스 적용
const createDebouncedHandler = (handler: HotkeyHandler, delay: number = 500): HotkeyHandler => {
  let timeoutId: number | null = null;

  return (e: KeyboardEvent) => {
    if (timeoutId !== null) {
      window.clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(() => {
      handler(e);
      timeoutId = null;
    }, delay);
  };
};

// 핫키 등록 함수 수정
export const registerHotkey = (
  keyCombo: string,
  handler: HotkeyHandler,
  options: { debounce?: number } = {}
) => {
  const { debounce } = options;
  const normalizedKey = keyCombo.toLowerCase();

  // 디바운스가 필요한 경우 핸들러에 적용
  const finalHandler = debounce ? createDebouncedHandler(handler, debounce) : handler;

  hotkeys.set(normalizedKey, finalHandler);

  if (!isInitialized) {
    initializeHotkeys();
    isInitialized = true;
  }

  // 등록 해제 함수 반환
  return () => {
    hotkeys.delete(normalizedKey);
  };
};

// 이벤트 리스너 초기화
const initializeHotkeys = () => {
  document.addEventListener("keydown", (e: KeyboardEvent) => {
    // 현재 포커스가 input, textarea, select인 경우 무시
    // const target = e.target as HTMLElement;
    // if (["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)) {
    //   return;
    // }

    const keys = [];

    // 조합키 추가
    if (e.ctrlKey || e.metaKey) keys.push("ctrl");
    if (e.altKey) keys.push("alt");
    if (e.shiftKey) keys.push("shift");

    // 일반 키 추가 (특수키 제외)
    if (!["Control", "Alt", "Shift", "Meta"].includes(e.key)) {
      keys.push(e.key.toLowerCase());
    }

    const keyCombo = keys.join("+");
    const handler = hotkeys.get(keyCombo);

    if (handler) {
      e.preventDefault();
      handler(e);
    }
  });
};
